exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flow-list[data-v-1af19054]  .el-tabs .el-tabs__content{height:calc(100% - 55px)}", ""]);

// exports
